import * as React from 'react';

class CloseSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        fill="none"
        className={`svg-icon close-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M8.41003 7.00003L13.7 1.71003C13.8639 1.51873 13.9495 1.27265 13.9397 1.02097C13.93 0.769298 13.8257 0.530558 13.6476 0.352463C13.4695 0.174369 13.2308 0.0700379 12.9791 0.0603168C12.7274 0.0505956 12.4813 0.1362 12.29 0.300027L7.00003 5.59003L1.71003 0.300027C1.51873 0.1362 1.27265 0.0505956 1.02097 0.0603168C0.769298 0.0700379 0.530558 0.174369 0.352463 0.352463C0.174369 0.530558 0.0700379 0.769298 0.0603168 1.02097C0.0505956 1.27265 0.1362 1.51873 0.300027 1.71003L5.59003 7.00003L0.300027 12.29C0.1362 12.4813 0.0505956 12.7274 0.0603168 12.9791C0.0700379 13.2308 0.174369 13.4695 0.352463 13.6476C0.530558 13.8257 0.769298 13.93 1.02097 13.9397C1.27265 13.9495 1.51873 13.8639 1.71003 13.7L7.00003 8.41003L12.29 13.7C12.4813 13.8639 12.7274 13.9495 12.9791 13.9397C13.2308 13.93 13.4695 13.8257 13.6476 13.6476C13.8257 13.4695 13.93 13.2308 13.9397 12.9791C13.9495 12.7274 13.8639 12.4813 13.7 12.29L8.41003 7.00003Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default CloseSvg;
